/**
 * Semantic color tokens (light theme = app default).
 * Values are applied to CSS variables in theme/themes.js — do not use raw hex in TRA components.
 */
export const darkColors = {
  canvas: "#eceef3",
  background: "#070b26",
  backgroundMid: "#0d1440",
  backgroundTop: "#16215a",
  surface: "rgba(255,255,255,0.05)",
  surfaceRaised: "rgba(255,255,255,0.06)",
  border: "rgba(255,255,255,0.08)",
  borderStrong: "rgba(255,255,255,0.12)",
  primary: "#34c77b",
  primaryMuted: "#1a5c3e",
  onPrimary: "#070b26",
  accent: "#f2a93b",
  purple: "#6f63e6",
  teamA: "#ff7a59",
  teamB: "#4fd6e0",
  danger: "#ff6b6b",
  success: "#34c77b",
  text: "#ffffff",
  textSecondary: "#c7cdec",
  textMuted: "#9aa3c7",
  textFaint: "#6b74a0",
  /** Legacy match UI (`C.txtD`) — preserved for visual parity during migration */
  textDim: "#8890b5",
  focusRing: "rgba(110,231,183,0.55)",
  warning: "#f2a93b",
  info: "#6f63e6",
  courtNet: "#e8f4f8",
  borderBright: "rgba(255,255,255,0.2)",
};

export const lightColors = {
  canvas: "#e8ecf4",
  background: "#f4f7fb",
  backgroundMid: "#eef2f8",
  backgroundTop: "#ffffff",
  surface: "#ffffff",
  surfaceRaised: "#f8fafc",
  border: "rgba(12, 25, 48, 0.08)",
  borderStrong: "rgba(12, 25, 48, 0.12)",
  primary: "#12b76a",
  primaryMuted: "#dcfae6",
  onPrimary: "#ffffff",
  accent: "#d97706",
  purple: "#4f46e5",
  teamA: "#e85d4a",
  teamB: "#0f766e",
  danger: "#dc2626",
  success: "#12b76a",
  text: "#0c1929",
  textSecondary: "#334155",
  textMuted: "#64748b",
  textFaint: "#94a3b8",
  textDim: "#64748b",
  focusRing: "rgba(18, 183, 106, 0.35)",
  warning: "#d97706",
  info: "#2563eb",
  courtNet: "#0c1929",
  borderBright: "rgba(12, 25, 48, 0.16)",
};

/** Approved Claude Player Profile — light (reference HTML). */
export const profileClaudeLight = {
  canvas: "#FAFAF8",
  background: "#FAFAF8",
  backgroundMid: "#FAFAF8",
  backgroundTop: "#FAFAF8",
  surface: "#FAFAF8",
  surfaceRaised: "#FAFAF8",
  border: "rgba(18, 18, 18, 0.1)",
  borderStrong: "rgba(18, 18, 18, 0.22)",
  primary: "#12b76a",
  primaryMuted: "rgba(18, 183, 106, 0.1)",
  onPrimary: "#FAFAF8",
  accent: "#0E8F63",
  purple: "#4f46e5",
  teamA: "#e85d4a",
  teamB: "#0f766e",
  danger: "#dc2626",
  success: "#12b76a",
  text: "#121212",
  textSecondary: "rgba(18, 18, 18, 0.8)",
  textMuted: "rgba(18, 18, 18, 0.45)",
  textFaint: "rgba(18, 18, 18, 0.38)",
  textDim: "rgba(18, 18, 18, 0.42)",
  focusRing: "rgba(18, 183, 106, 0.35)",
  warning: "#d97706",
  info: "#2563eb",
  courtNet: "#121212",
  borderBright: "rgba(18, 18, 18, 0.16)",
};

/** Approved Claude Player Profile — dark (reference HTML). */
export const profileClaudeDark = {
  canvas: "#121212",
  background: "#121212",
  backgroundMid: "#121212",
  backgroundTop: "#121212",
  surface: "#121212",
  surfaceRaised: "#121212",
  border: "rgba(250, 250, 248, 0.09)",
  borderStrong: "rgba(250, 250, 248, 0.18)",
  primary: "#34c77b",
  primaryMuted: "rgba(52, 199, 123, 0.12)",
  onPrimary: "#121212",
  accent: "#34c77b",
  purple: "#6f63e6",
  teamA: "#ff7a59",
  teamB: "#4fd6e0",
  danger: "#ff6b6b",
  success: "#34c77b",
  text: "#FAFAF8",
  textSecondary: "rgba(250, 250, 248, 0.8)",
  textMuted: "rgba(250, 250, 248, 0.42)",
  textFaint: "rgba(250, 250, 248, 0.35)",
  textDim: "rgba(250, 250, 248, 0.4)",
  focusRing: "rgba(52, 199, 123, 0.4)",
  warning: "#f2a93b",
  info: "#6f63e6",
  courtNet: "#FAFAF8",
  borderBright: "rgba(250, 250, 248, 0.2)",
};
